const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const USER_API = {
  REGISTER: `${BASE_URL}/auth/register/`,
  LOGIN: `${BASE_URL}/auth/login/`,
  GOOGLE_LOGIN: `${BASE_URL}/auth/google-login/`,
  APPLE_LOGIN: `${BASE_URL}/auth/apple-login/`,
  VERIFY_SIGNUP_OTP: `${BASE_URL}/auth/verify-otp/`,
  CONTACT_US: `${BASE_URL}/auth/contact-us/`,
  RESEND_SIGNUP_OTP: `${BASE_URL}/auth/resend-otp/`,
  FORGET_PASSWORD: `${BASE_URL}/auth/password/forgot/`,
  VERIFY_RESET_OTP: `${BASE_URL}/auth/password/reset/otp/`,
  RESET_PASSWORD: `${BASE_URL}/auth/password/reset/token/`,
  USER_INFO: `${BASE_URL}/auth/user/info/`,
  DELETE_ACCOUNT: `${BASE_URL}/auth/delete-account/`,

  RACES_BY_DATE: `${BASE_URL}/dashboard/races-by-date/`,
  RACES: `${BASE_URL}/dashboard/races/`,
  VENUE_VISIBILITY: `${BASE_URL}/dashboard/admin/venue-visibility/`,
  ADMIN_USERS: `${BASE_URL}/auth/admin/users/`,
  SUBSCRIPTION_PLANS: `${BASE_URL}/subscriptions/admin/plans/`,
  SUBSCRIPTION_PRICE_POINTS: `${BASE_URL}/subscriptions/admin/apple-price-points/`,
  ADMIN_SUBSCRIBERS: `${BASE_URL}/subscriptions/admin/subscribers/`,
  ADMIN_PAYMENTS: `${BASE_URL}/subscriptions/admin/payments/`,
  COMPARISON: `${BASE_URL}/dashboard/comparison-results/aggregated/`,
  COMPARISON_STATS: `${BASE_URL}/dashboard/comparison-results/stats/`,
  LANDING_PAGE_STATS: `${BASE_URL}/dashboard/landing-page-stats/`,
  FEATURE_IMPORTANCE: `${BASE_URL}/dashboard/model-training-history/`,
  ACCURACY_TRENDS: `${BASE_URL}/accuracy-trends/monthly/`,
  EXPORT_PREDICTIONS: `${BASE_URL}/dashboard/admin/export-predictions/`,
  EXPORT_USERS: `${BASE_URL}/dashboard/admin/export-users/`,

  LOG_USAGE: `${BASE_URL}/analytics/usage/`,
  LOGIN_STATS: `${BASE_URL}/analytics/login-stats/`,
  USAGE_STATS: `${BASE_URL}/analytics/usage-stats/`,

  NOTIFICATIONS: {
    DEVICES: `${BASE_URL}/notifications/devices/`,
    LIST: `${BASE_URL}/notifications/manage/`,
    MY_NOTIFICATIONS: `${BASE_URL}/notifications/my-notifications/`,
  },
};
